interface Props {
  highlightColor?: string;
  width?: number;
  height?: number;
}

export const ReferralIcon = ({ highlightColor, width, height }: Props) => {
  const color = "#00000";

  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 194.16 195.33"
      width={width}
      height={height}
    >
      <g id="Layer_1-2">
        <path
          fill={color}
          d="m18.83,57.82c-.32,0-.65-.06-.96-.19-1.27-.53-1.88-2-1.35-3.27,1.86-4.46,4.12-8.81,6.71-12.91.74-1.17,2.28-1.51,3.45-.78,1.17.74,1.51,2.28.78,3.45-2.44,3.87-4.57,7.96-6.33,12.16-.4.96-1.33,1.54-2.31,1.54Z"
        />
        <path
          fill={color}
          d="m64.47,134.49c-.55,0-1.1-.18-1.56-.55-5.33-4.27-9.77-9.43-13.19-15.34-.69-1.2-.28-2.72.91-3.42,1.19-.69,2.72-.29,3.42.91,3.11,5.37,7.15,10.07,11.99,13.95,1.08.86,1.25,2.44.39,3.51-.49.62-1.22.94-1.95.94Z"
        />
        <path
          fill={color}
          d="m129.7,134.49c-.73,0-1.46-.32-1.95-.94-.86-1.08-.69-2.65.39-3.51,11.84-9.49,18.64-23.63,18.64-38.79,0-20.35-12.19-38.43-31.05-46.07-1.28-.52-1.9-1.98-1.38-3.26.52-1.28,1.98-1.9,3.26-1.38,20.76,8.41,34.17,28.31,34.17,50.71,0,16.69-7.48,32.25-20.51,42.69-.46.37-1.01.55-1.56.55Z"
        />
        <path
          fill={color}
          d="m51.87,67.66c-.43,0-.86-.11-1.25-.34-1.19-.69-1.6-2.22-.91-3.42,3.42-5.9,7.85-11.06,13.19-15.34,1.08-.87,2.65-.69,3.51.39.86,1.08.69,2.65-.39,3.51-4.85,3.89-8.88,8.58-11.99,13.95-.46.8-1.3,1.25-2.17,1.25Z"
        />
        <path
          fill={color}
          d="m132.94,13.65c-.35,0-.71-.08-1.06-.24-10.93-5.11-22.64-7.7-34.8-7.7-10.99,0-21.65,2.13-31.7,6.33-1.27.53-2.74-.07-3.27-1.34-.53-1.27.07-2.74,1.34-3.27C74.12,2.97,85.43.72,97.08.72c12.9,0,25.32,2.75,36.92,8.17,1.25.58,1.79,2.07,1.21,3.32-.42.91-1.33,1.44-2.27,1.44Z"
        />
        <path
          fill={color}
          d="m177.77,116.57c-.25,0-.51-.04-.77-.12-1.31-.42-2.04-1.83-1.61-3.15,2.63-8.15,3.96-16.66,3.96-25.31,0-7.53-1.02-14.99-3.02-22.16-.37-1.33.41-2.71,1.74-3.08,1.33-.37,2.71.41,3.08,1.74,2.13,7.61,3.2,15.52,3.2,23.5,0,9.17-1.42,18.2-4.21,26.85-.34,1.06-1.32,1.73-2.38,1.73Z"
        />
        <path
          fill={color}
          d="m119.9,172.15c-1.09,0-2.1-.72-2.41-1.83-.37-1.33.41-2.71,1.74-3.08,12.62-3.52,24.38-10.13,34.01-19.13,1.01-.94,2.59-.89,3.53.12.94,1.01.89,2.59-.12,3.53-10.21,9.54-22.69,16.56-36.08,20.3-.22.06-.45.09-.67.09Z"
        />
        <path
          fill={color}
          d="m73.72,172c-.23,0-.46-.03-.69-.1-22.89-6.55-42.35-22.45-53.39-43.64-.64-1.22-.16-2.73,1.06-3.37,1.22-.64,2.73-.16,3.37,1.06,10.41,19.97,28.75,34.97,50.33,41.14,1.33.38,2.1,1.76,1.72,3.09-.31,1.1-1.31,1.81-2.4,1.81Z"
        />
        <path
          fill={highlightColor || color}
          d="m28.38,119.63c-15.65,0-28.38-12.73-28.38-28.38s12.73-28.38,28.38-28.38,28.38,12.73,28.38,28.38-12.73,28.38-28.38,28.38Zm0-51.77c-12.89,0-23.38,10.49-23.38,23.38s10.49,23.38,23.38,23.38,23.38-10.49,23.38-23.38-10.49-23.38-23.38-23.38Z"
        />
        <path
          fill={highlightColor || color}
          d="m28.38,100.5c-6.91,0-12.52-5.62-12.52-12.52s5.62-12.52,12.52-12.52,12.52,5.62,12.52,12.52-5.62,12.52-12.52,12.52Zm0-20.04c-4.15,0-7.52,3.38-7.52,7.52s3.38,7.52,7.52,7.52,7.52-3.38,7.52-7.52-3.38-7.52-7.52-7.52Z"
        />
        <path
          fill={color}
          d="m97.08,77.97c-8.57,0-15.55,6.98-15.55,15.55,0,4.61,2.02,8.76,5.22,11.61,1.54,1.37,3.35,2.44,5.34,3.12,1.31.44,2.7.72,4.14.8.28.01.56.02.85.02.31,0,.61-.01.91-.03,1.45-.08,2.85-.36,4.16-.82,1.96-.68,3.74-1.74,5.26-3.09,3.2-2.85,5.22-7,5.22-11.61,0-8.57-6.98-15.55-15.55-15.55Zm0,26.1c-5.81,0-10.55-4.73-10.55-10.55s4.74-10.55,10.55-10.55,10.55,4.74,10.55,10.55-4.73,10.55-10.55,10.55Z"
        />
        <path
          fill={highlightColor || color}
          d="m165.78,57.48c-15.65,0-28.38-12.73-28.38-28.38S150.13.71,165.78.71s28.38,12.73,28.38,28.38-12.73,28.38-28.38,28.38Zm0-51.77c-12.89,0-23.38,10.49-23.38,23.38s10.49,23.38,23.38,23.38,23.38-10.49,23.38-23.38-10.49-23.38-23.38-23.38Z"
        />
        <path
          fill={highlightColor || color}
          d="m30.54,38.67c-.52,0-1.03-.16-1.47-.48-.77-.56-1.16-1.51-.99-2.45l1.87-10.88-7.91-7.71c-.68-.66-.93-1.66-.63-2.56s1.08-1.56,2.02-1.7l10.93-1.59,4.89-9.9c.42-.85,1.29-1.39,2.24-1.39s1.82.54,2.24,1.39l4.89,9.9,10.93,1.59c.94.14,1.72.8,2.02,1.7s.05,1.9-.63,2.56l-7.91,7.71,1.87,10.88c.16.94-.22,1.89-.99,2.45-.77.56-1.79.63-2.63.19l-9.78-5.14-9.78,5.14c-.37.19-.76.29-1.16.29Zm10.94-10.75c.4,0,.8.1,1.16.29l6.46,3.39-1.23-7.19c-.14-.81.13-1.64.72-2.21l5.22-5.09-7.22-1.05c-.81-.12-1.52-.63-1.88-1.37l-3.23-6.54-3.23,6.54c-.36.74-1.07,1.25-1.88,1.37l-7.22,1.05,5.22,5.09c.59.57.86,1.4.72,2.21l-1.23,7.19,6.46-3.39c.36-.19.76-.29,1.16-.29Z"
        />
        <path
          fill={highlightColor || color}
          d="m10.88,112.82c-.29,0-.58-.05-.86-.15-1.3-.48-1.96-1.91-1.49-3.21,3.04-8.29,11.01-13.9,19.83-13.96h.14c8.8,0,16.79,5.51,19.9,13.76.49,1.29-.16,2.73-1.45,3.22-1.29.49-2.73-.16-3.22-1.45-2.38-6.31-8.5-10.53-15.23-10.53h-.11c-6.75.04-12.85,4.34-15.17,10.68-.37,1.01-1.33,1.64-2.35,1.64Z"
        />
        <path
          fill={highlightColor || color}
          d="m165.69,38.4c-6.91,0-12.52-5.62-12.52-12.52s5.62-12.52,12.52-12.52,12.52,5.62,12.52,12.52-5.62,12.52-12.52,12.52Zm0-20.04c-4.15,0-7.52,3.38-7.52,7.52s3.38,7.52,7.52,7.52,7.52-3.38,7.52-7.52-3.38-7.52-7.52-7.52Z"
        />
        <path
          fill={highlightColor || color}
          d="m148.18,50.72c-.29,0-.58-.05-.86-.15-1.3-.48-1.96-1.91-1.49-3.21,3.04-8.29,11.01-13.9,19.83-13.96h.14c8.8,0,16.79,5.51,19.9,13.76.49,1.29-.16,2.73-1.45,3.22-1.29.49-2.73-.16-3.22-1.45-2.38-6.31-8.5-10.53-15.23-10.53h-.11c-6.75.04-12.85,4.34-15.17,10.68-.37,1.01-1.33,1.64-2.35,1.64Z"
        />
        <path
          fill={highlightColor || color}
          d="m106.9,51.14h-10.23c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h7.73v-14.33h-27.71v14.33h7.35c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5h-9.85c-1.38,0-2.5-1.12-2.5-2.5v-19.33c0-1.38,1.12-2.5,2.5-2.5h32.71c1.38,0,2.5,1.12,2.5,2.5v19.33c0,1.38-1.12,2.5-2.5,2.5Z"
        />
        <path
          fill={highlightColor || color}
          d="m93.51,64.78c-.81,0-1.58-.39-2.05-1.07l-9.47-13.64c-.79-1.13-.51-2.69.63-3.48,1.13-.79,2.69-.51,3.48.63l6.25,9.01,1.88-8.14c.31-1.34,1.66-2.18,3-1.87,1.35.31,2.18,1.65,1.87,3l-3.16,13.64c-.22.96-.99,1.71-1.96,1.89-.16.03-.32.04-.47.04Z"
        />
        <path
          fill={color}
          d="m99.6,192.83c0,1.38-1.09,2.5-2.47,2.5h-13.15c-.66,0-1.3-.26-1.77-.73-.47-.47-.73-1.11-.73-1.77.01-13.71.01-27.41.02-41.11l-8.5-5.8c-.67-.45-1.08-1.2-1.1-2.01-.12-5.87-.13-11.87-.05-17.84.13-8.96.39-11.56,2.06-14.16,2.72-4.23,7.69-6.1,12.84-6.78,1.54-.2,3.1-.3,4.61-.31h1.15c.89,0,1.76.04,2.59.09h.06c1.05.12,1.58.15,1.85.16.25,0,.28-.01.31.01.35.29.22,1.31-.18,2.33-.23.59-.54,1.19-.91,1.64-.29.37-.61.65-.93.77h-2.88c-4.98-.04-11.69.73-14.31,4.8-.88,1.37-1.14,2.95-1.26,11.52-.08,5.48-.07,10.98.03,16.38l8.52,5.81c.69.46,1.1,1.24,1.1,2.07-.01,13.31-.01,26.62-.02,39.93h10.6c1.38,0,2.52,1.12,2.52,2.5Z"
        />
        <path
          fill={color}
          d="m122.3,143.91c-.01.81-.42,1.56-1.09,2.01l-8.5,5.8c.01,13.7.01,27.4.02,41.1,0,.66-.27,1.3-.74,1.77-.46.47-1.1.74-1.76.74h-13.1c-1.38,0-2.53-1.12-2.53-2.5s1.1-2.5,2.48-2.5h10.65c0-13.32,0-26.63-.02-39.93,0-.83.41-1.61,1.09-2.07l8.53-5.81c.1-5.4.11-10.91.03-16.38-.12-8.56-.38-10.15-1.26-11.52-2.54-3.96-8.94-4.79-13.89-4.8h-3.36c-.3-.13-.59-.42-.86-.78-.34-.45-.64-1.04-.85-1.62h0c-.39-1.04-.52-2.06-.17-2.34,0-.01.02-.01.03-.01h.01c.17-.06.82-.07,1.97-.16h.04c.84-.05,1.72-.09,2.62-.09h.37c1.76,0,3.59.08,5.4.31,5.18.67,10.16,2.54,12.89,6.79,1.67,2.59,1.93,5.19,2.06,14.15.08,5.97.07,11.97-.06,17.84Z"
        />
        <path
          fill={highlightColor || color}
          d="m172.16,151.72c-.63,0-1.25-.23-1.74-.7l-3.97-3.83c-.28-.23-.52-.44-.75-.67-.03-.03-.1-.1-.15-.16l-9.69-9.53c-1.85-1.82-2.8-4.37-2.6-6.97.2-2.6,1.53-4.97,3.66-6.5,3.49-2.51,8.31-2.09,11.46,1.02l3.62,3.56,3.62-3.56c3.16-3.1,7.98-3.53,11.46-1.02h0c2.12,1.53,3.46,3.9,3.66,6.5.2,2.61-.75,5.15-2.6,6.97l-8.2,8.07-6.01,6.08c-.49.5-1.13.74-1.78.74Zm-2.86-8.68c.12.11.23.2.34.29.07.05.13.11.19.17l2.28,2.2,4.3-4.35,8.22-8.09c.8-.79,1.21-1.89,1.12-3.03-.09-1.14-.65-2.15-1.59-2.83-1.48-1.07-3.64-.84-5.03.53l-5.37,5.29c-.97.96-2.53.96-3.51,0l-5.37-5.29c-1.39-1.37-3.55-1.59-5.03-.52-.94.68-1.51,1.68-1.59,2.83-.09,1.14.32,2.24,1.12,3.03l9.75,9.6s.05.05.08.08c.02.02.06.06.09.1Z"
        />
        <polygon
          fill={color}
          points="102.21 109.82 92.42 109.82 92.09 108.25 91.36 104.82 102.01 104.82 102.15 108.22 102.21 109.82"
        />
      </g>
    </svg>
  );
};
